const NoPermissionFoundIcon = () => {
    return (
        <svg
            width="240"
            height="280"
            viewBox="0 0 240 280"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="240" height="240" rx="20" fill="#F5F8FF" />
            <circle cx="120" cy="90" r="50" fill="#E0EAFF" />
            <path
                d="M140 90V72C140 56 100 56 100 72V90"
                stroke="#A5B4FC"
                strokeWidth="8"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
            <rect
                x="95"
                y="90"
                width="50"
                height="60"
                rx="10"
                fill="#4F46E5"
                stroke="#4338CA"
                strokeWidth="2"
            />
            <circle cx="120" cy="120" r="6" fill="#FACC15" />
            <path d="M120 126 v8" stroke="#FACC15" strokeWidth="2" />
            <g transform="translate(105, 105)">
                <circle cx="15" cy="15" r="14" fill="#F87171" />
                <path
                    d="M10 10 L20 20 M20 10 L10 20"
                    stroke="#FFF"
                    strokeWidth="2"
                    strokeLinecap="round"
                />
            </g>
            <circle cx="40" cy="40" r="4" fill="#F472B6" />
            <circle cx="190" cy="50" r="3" fill="#60A5FA" />
            <circle cx="180" cy="190" r="3.5" fill="#34D399" />
            <circle cx="50" cy="185" r="2.5" fill="#FBBF24" />

            <ellipse cx="120" cy="170" rx="40" ry="6" fill="#E0E7FF" />

            <text
                x="50%"
                y="220"
                text-anchor="middle"
                fill="#5f7087ff"
                font-size="16"
                font-family="Segoe UI, sans-serif"
                font-weight="600"
            >
                No Permissions Found
            </text>
        </svg>
    )
}

export default NoPermissionFoundIcon
